import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import LocalDate from '../LocalDate'
import ShowLocalNumber from '../ShowLocalNumber'
import PropTypes from 'prop-types';
class ReportCommesseFattureProforme extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items:[],
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.tipo, this.props.commessa.idCommessa, this.props.dataStart, this.props.dataEnd);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.tipo !== this.props.tipo || nextProps.commessa !== this.props.commessa || nextProps.dataStart !== this.props.dataStart || nextProps.dataEnd !== this.props.dataEnd)
        {
            this.loadData(nextProps.tipo,  nextProps.commessa.idCommessa, nextProps.dataStart, nextProps.dataEnd);
        }
    }

    loadData(tipo, idCommessa, dataStart, dataEnd) {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportCommesseFattureProforme(tipo, idCommessa, dataStart, dataEnd).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                    <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui grid">
            <div className="sixteen wide column">
                {this.renderMovimenti(this.state.items, this.props.tipo)}
            </div>
            {loader}
        </div>)
    }

    renderMovimenti(items, tipo){
        let i=0;
        let sommaCorrispettivo = 0;
        let sommaPagamento = 0;
        return (
            <Table celled >
                <Table.Body>
                    <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                        <Table.Cell>
                            ID
                        </Table.Cell>
                        <Table.Cell>
                            Data (Anno comp.)
                        </Table.Cell>
                        <Table.Cell>
                            PDC
                        </Table.Cell>
                        <Table.Cell>
                            Soggetto
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            E/C
                        </Table.Cell>
                        <Table.Cell>
                            Causale
                        </Table.Cell>
                        <Table.Cell>
                            Forma
                        </Table.Cell>
                        <Table.Cell>
                            Corrispettivo
                        </Table.Cell>
                        <Table.Cell>
                            Pagamento
                        </Table.Cell>
                    </Table.Row>
                    {
                        items.map((item) => {
                            sommaCorrispettivo += Number.parseFloat(item.corrispettivo);
                            sommaPagamento += Number.parseFloat(item.pagamento);
                            return <Table.Row key={i++}>
                                <Table.Cell>{item.idMovimento}</Table.Cell>
                                <Table.Cell><LocalDate data={item.data}/></Table.Cell>
                                <Table.Cell>{item.idPdc.nomeCompleto}</Table.Cell>
                                <Table.Cell>{item.soggetto}</Table.Cell>
                                <Table.Cell  textAlign='center'>{item.estrConto}</Table.Cell>
                                <Table.Cell>{item.causale}</Table.Cell>
                                <Table.Cell>{item.forma}</Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.corrispettivo}/></Table.Cell>
                                <Table.Cell textAlign="right"><ShowLocalNumber value={item.pagamento}/></Table.Cell>
                            </Table.Row>
                        })}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan={7}  textAlign="right">Totali</Table.HeaderCell>
                        <Table.HeaderCell  textAlign='right'><b><ShowLocalNumber value={sommaCorrispettivo}/></b></Table.HeaderCell>
                        <Table.HeaderCell  textAlign='right'><b><ShowLocalNumber value={sommaPagamento}/></b></Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        )
    }
}

ReportCommesseFattureProforme.PropTypes = {
    commessa: PropTypes.object.isRequired,
    dataStart: PropTypes.string.isRequired,
    dataEnd: PropTypes.string.isRequired,
    tipo: PropTypes.oneOf(['F', 'P']), // F=Fatture P=Proforme
}

export default ReportCommesseFattureProforme;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseFattureProforme.js
 **/